export const dataLayer = {
  track: (event, eventData = {}) => {
    try {
      window.dataLayer.push({ event, ...eventData });
    } catch (e) {}
  },
};



// WEBPACK FOOTER //
// ./src/utils/dataLayer.js